import React, { useContext, useEffect, useState, useRef } from 'react';
import { IProps } from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import { useSelector } from 'react-redux';
import { IDSConfig } from '@state/dsconfig/types';
import selectors from '@state/selectors';
import ToggleSwitch from '@components/ToggleSwitch';
import { GearIcon } from '@assets/icons/gearIcon';

const DescribedLayerColor: React.FC<IProps> = (props) => {
  
  const context = useContext(Context);
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);

  const [open, setOpen] = useState(false);

  const useOutsideAlerter = (ref:any) => {
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const handleOpen = () => {
    setOpen(!open);
  }

  return (
    <S.Root
      ref={wrapperRef}
    >
      <S.ColorIconContainer
        onClick={handleOpen}
        openValue={open}
      >
        <GearIcon
        />
      </S.ColorIconContainer>
      {
        open &&
        <S.ColorsContainer>
          <S.Title>
            Highlight Described Layers 
          </S.Title>
          <S.SwitchContainer>
            On
            <S.SwitchPadding>
              <ToggleSwitch
                id="checkbox-colors"
                onChange={() => context.onShowDescribedLayerColor(!context.editorStatus.showDescribedLayerColor)} 
                checked={!context.editorStatus.showDescribedLayerColor} style={{ display: "inline-block" }}
              />
            </S.SwitchPadding>
            Off
          </S.SwitchContainer>
          <S.ColorTitle>
            Code:
          </S.ColorTitle>
          <S.ColorsOptions>
            { 
              dsConfig.selectDescribeConfig.categories.map(category => {
                if (category.color) { return (
                  <S.ColorRow>
                    <S.Color
                      colorValue={category.color}
                    />
                    <S.ColorText>
                      {category.name}
                    </S.ColorText>
                  </S.ColorRow>
                )}
              })
            }
          </S.ColorsOptions>
        </S.ColorsContainer>
      }
    </S.Root>
  );
}

export default DescribedLayerColor;